import { useState } from 'react';
import { Box, ThemeProvider, createTheme, CssBaseline } from '@mui/material';
import Sidebar, { SIDEBAR_W, SIDEBAR_W_MIN } from './components/Sidebar';
import TopBar from './components/TopBar';
import DashboardRouter from './dashboard/DashboardRouter';
import ManageEntity    from './manage/ManageEntity';
import Event from './dashboard/events/pages/Event'
import Settings        from './settings/Settings';

// ── Theme ─────────────────────────────────────────────────────────────────
const theme = createTheme({
  palette: { mode: 'dark', primary: { main: '#D4AF37' }, secondary: { main: '#22C55E' } },
  typography: { fontFamily: '"Sora", "Outfit", "Inter", sans-serif' },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          background: '#060912',
          '&::-webkit-scrollbar': { width: 6 },
          '&::-webkit-scrollbar-track': { background: '#060912' },
          '&::-webkit-scrollbar-thumb': { background: 'rgba(212,175,55,.25)', borderRadius: 3 },
        },
      },
    },
    MuiPaper: { styleOverrides: { root: { backgroundImage: 'none' } } },
  },
});

// ── Section router ─────────────────────────────────────────────────────────
// Add new sections here as you build them
const SECTIONS = {
  dashboard: <DashboardRouter />,
  manage:    <ManageEntity />,
  event:     <Event />,
  settings:  <Settings />,
};

const ProfilePage = () => {
  const [section, setSection]     = useState('dashboard');
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box sx={{ display: 'flex', minHeight: '100vh', bgcolor: '#060912' }}>

        {/* Sidebar */}
        <Sidebar
          activeSection={section}
          onNavigate={setSection}
          mobileOpen={mobileOpen}
          onMobileClose={() => setMobileOpen(false)}
        />

        {/* Main content */}
        <Box sx={{
          flex: 1,
          minWidth: 0,
          display: 'flex',
          flexDirection: 'column',
          // Push content right of sidebar on desktop
          ml: { md: 0 },
        }}>
          {/* Mobile top bar */}
          <TopBar onMenuClick={() => setMobileOpen(true)} activeSection={section} />

          {/* Page content */}
          <Box sx={{
            flex: 1,
            mt: { xs: 8, md: 0 },       // offset mobile topbar
            p: { xs: 2, sm: 3, md: 4 },
            maxWidth: 1400,
            width: '100%',
            mx: 'auto',
          }}>
            {SECTIONS[section] ?? SECTIONS.dashboard}
          </Box>
        </Box>
      </Box>
    </ThemeProvider>
  );
};

export default ProfilePage;